var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcGroup({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.66663 6.66667H4.99996C6.33329 6.66667 6.99996 6 6.99996 4.66667V3.33334C6.99996 2 6.33329 1.33334 4.99996 1.33334H3.66663C2.33329 1.33334 1.66663 2 1.66663 3.33334V4.66667C1.66663 6 2.33329 6.66667 3.66663 6.66667Z",
    stroke: "#0A49A5",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6666 6.66667H13C14.3333 6.66667 15 6 15 4.66667V3.33334C15 2 14.3333 1.33334 13 1.33334H11.6666C10.3333 1.33334 9.66663 2 9.66663 3.33334V4.66667C9.66663 6 10.3333 6.66667 11.6666 6.66667Z",
    stroke: "#0A49A5",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6666 14.6667H13C14.3333 14.6667 15 14 15 12.6667V11.3333C15 10 14.3333 9.33334 13 9.33334H11.6666C10.3333 9.33334 9.66663 10 9.66663 11.3333V12.6667C9.66663 14 10.3333 14.6667 11.6666 14.6667Z",
    stroke: "#0A49A5",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3.66663 14.6667H4.99996C6.33329 14.6667 6.99996 14 6.99996 12.6667V11.3333C6.99996 10 6.33329 9.33334 4.99996 9.33334H3.66663C2.33329 9.33334 1.66663 10 1.66663 11.3333V12.6667C1.66663 14 2.33329 14.6667 3.66663 14.6667Z",
    stroke: "#0A49A5",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcGroup);
export default __webpack_public_path__ + "static/media/ic_group.6d467979e660e856ceecd0d70c28ed6e.svg";
export { ForwardRef as ReactComponent };